module.exports = __webpack_public_path__ + "img/vegetable-watercress-350x184.a18b7673.jpg";